import { Component, OnDestroy, OnInit } from '@angular/core';
import { MetaSetterService } from 'src/app/general/meta-setter.service';
import { BlockConfigService } from 'src/app/block-config.service';
import { BlogService } from 'src/app/blog.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { BlockConfigurationObject } from 'src/app/block-configuration-object.model';
import { environment } from 'src/environments/environment';

@Component({
	selector: 'app-golf-tournament-page',
	templateUrl: './golf-tournament-page.component.html',
	styleUrls: ['./golf-tournament-page.component.scss']
})
export class GolfTournamentPageComponent implements OnInit, OnDestroy {

	trustedDesc: SafeHtml;
	trustedCopy: SafeHtml;

	tournConfig: BlockConfigurationObject = null;

	environment = environment;

	constructor(
		private metaSetter: MetaSetterService,
		private blogService: BlogService,
		private blockConfig: BlockConfigService,
		private sanitiser: DomSanitizer,
	) {

	}

	ngOnInit(): void {
		this.retrieveAndSetMetadata();
		this.activateGolfTournamentBlock();
		
	}

	activateGolfTournamentBlock(): void {
		if (typeof window !== "undefined" && typeof document !== "undefined") {
			this.tournConfig = {
				...this.blockConfig.getGlobalBlockConfig(),
				tournamentID: "GOLF_AUTO"
			};
		}
	}

	retrieveAndSetMetadata(): void {
		this.blogService.getAppSettings("golf-tournament")
			.subscribe(settings => {
				this.metaSetter.setMeta({
					title: settings.app_title,
					seoTitle: settings.seo_title,
					description: settings.seo_description || settings.app_description,
					metaImageURL: environment.defaultMetaImage,
					canonicalURL: environment.canonicalDomain + "/sport-hub/golf/next",
				});

				this.trustedDesc = this.sanitiser.bypassSecurityTrustHtml(settings.app_page_subheader);
				this.trustedCopy = this.sanitiser.bypassSecurityTrustHtml(settings.subheading_description);
			}, () => {
				this.metaSetter.setMeta({
					title: environment.siteTitle,
					description: environment.defaultMetaDescription,
					metaImageURL: environment.defaultMetaImage,
					canonicalURL: environment.canonicalDomain + "/sport-hub/golf/next",
				})
			});
	}
	
	ngOnDestroy(): void {
		// hack to clear out old golf tournament block
		if (typeof document !== "undefined") {
			const blockContainer = document.getElementById("si-external-golf-tournament");
			if (blockContainer) {
				blockContainer.remove();
			}
		}
	}

}
